import { DOCUMENTATION_URL, VITE_DISCORD_URL } from "@/constants";
import { UserMenu } from "@/features/Auth/components/UserMenu/UserMenu";
import { NavSidebar } from "@/features/Navigation/components/NavSidebar";
import { AppBanner } from "@/features/Notifications/AppBanner";
import { RegistrationForm } from "@/features/Registration/components/RegistrationForm";
import {
  Divider,
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuList,
  Spacer,
  Stack,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import { Icon, MenuItem, Page, PageContent, PageContentHeader, ScrollableContent } from "@pufflig/prompt-studio-ui";
import { Outlet, useSearchParams } from "react-router-dom";

export const Homepage = () => {
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const teamId = searchParams.get("team") || undefined;
  const [isMobile] = useMediaQuery("(max-width: 767px)");

  return (
    <Page Banner={<AppBanner />}>
      {!isMobile && <NavSidebar />}
      <PageContent>
        <RegistrationForm />
        <PageContentHeader>
          <Spacer />
          <Stack gap="spacing-xs" direction="row">
            <Menu>
              <MenuButton
                variant="ghost"
                as={IconButton}
                paddingLeft="spacing-xs"
                paddingRight="spacing-xs"
                icon={<Icon name="more-info" size="md" />}
              />
              <MenuList>
                <Link _hover={{ textDecoration: "none" }} href={DOCUMENTATION_URL} target="_blank">
                  <MenuItem leftIcon={<Icon name="document-text-1" />} primaryLabel="Documentation" />
                </Link>
                <Link _hover={{ textDecoration: "none" }} href={VITE_DISCORD_URL} target="_blank">
                  <MenuItem leftIcon={<Icon name="sms" />} primaryLabel="Contact us" />
                </Link>
                <Divider my="spacing-xxs" />
                <MenuItem
                  onClick={() => {
                    navigator.clipboard.writeText(import.meta.env.VITE_GITHASH);
                    toast({
                      position: "top",
                      title: "Version number copied!",
                      status: "success",
                      duration: 1000,
                      isClosable: true,
                    });
                  }}
                  leftIcon={<Icon name="info-circle" />}
                  primaryLabel={`version ${import.meta.env.VITE_GITHASH.substring(0, 7)}`}
                />
              </MenuList>
            </Menu>
            <UserMenu teamId={teamId} />
          </Stack>
        </PageContentHeader>
        <ScrollableContent>
          <Outlet />
        </ScrollableContent>
      </PageContent>
    </Page>
  );
};
